const breadcrumbMapper = {
    mydashboard: {
        title: 'Dashboard',
        pageBreadcrumbPath: ['Home']
    },
    personalinfo: {
        title: 'Personal Info',
        pageBreadcrumbPath: ['Home']
    },
    todolist: {
        title: 'To Do List',
        pageBreadcrumbPath: ['Home']
    },
    approval: {
        title: 'Approval',
        pageBreadcrumbPath: ['To Do List']
    },
    revise: {
        title: 'Revise',
        pageBreadcrumbPath: ['To Do List']
    },
    draft: {
        title: 'Draft',
        pageBreadcrumbPath: ['To Do List']
    },
    cancel: {
        title: 'Cancel',
        pageBreadcrumbPath: ['To Do List']
    },
    approvalhistory: {
        title: 'Approval History',
        pageBreadcrumbPath: ['To Do List']
    },
    hrgs: {
        title: 'HR & GS Service',
        pageBreadcrumbPath: ['Home']
    },
    leave: {
        title: 'Leave',
        pageBreadcrumbPath: ['Home', 'HR & GS Service']
    },
    leaverequest: {
        title: 'Leave Request',
        pageBreadcrumbPath: ['Home', 'HR & GS Service']
    },
    masterdata: {
        title: 'Master Data',
        pageBreadcrumbPath: ['Home', 'PSCM Service']
    },
    conditiontypemaster: {
        title: 'Condition Type',
        pageBreadcrumbPath: ['Home', 'PSCM Service', 'Master Data']
    },
    materialtypemaster: {
        title: 'Material Type',
        pageBreadcrumbPath: ['Home', 'PSCM Service', 'Master Data']
    },
    mapvalclasstomattype: {
        title: 'Map Valuation Class To Material Type',
        pageBreadcrumbPath: ['Home', 'PSCM Service', 'Master Data']
    },
    mapmatgrouptovalclass: {
        title: 'Map Material Group To Valuation Class',
        pageBreadcrumbPath: ['Home', 'PSCM Service', 'Master Data']
    },
    pricelist: {
        title: 'Pricelist',
        pageBreadcrumbPath: ['Home', 'PSCM Service']
    },
    taskhistory: {
        title: 'Task History',
        pageBreadcrumbPath: ['Home']
    },
    archive: {
        title: 'Archive',
        pageBreadcrumbPath: ['Home', 'Task History']
    },
    current: {
        title: 'Current',
        pageBreadcrumbPath: ['Home', 'Task History']
    },
    masterthemes: {
        title: 'Theme',
        pageBreadcrumbPath: ['Home']
    },
    financereport: {
        title: 'Profiling Capex',
        pageBreadcrumbPath: ['Home']
    },
    financemaster: {
        title: '',
        pageBreadcrumbPath: ['Home']
    }
};
export { breadcrumbMapper };
